export default __webpack_public_path__ + "static/media/thumb-down.26f827f0.svg";